export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUt";
export const USERNAME = "USERNAME";
export const PASSWORD = "PASSWORD";
export const AUTHENTICATED = "AUTHENTICATED";